import styled from 'react-emotion'
import { typography, spacer } from 'stylist'

const Subheader = styled.span`
  ${typography('subheading3')};
  margin-right: ${spacer(3)};
`
export default Subheader



// WEBPACK FOOTER //
// ./src/components/Subheader.js